import Icon from '../../components/Icon.vue'

Icon.register({"brands/cc-diners-club":{"width":576,"height":512,"paths":[{"d":"M239.7 79.9C142.8 79.9 63.9 158.5 63.9 255.7 63.9 352.6 142.8 431.5 239.7 431.5 336.9 431.5 415.5 352.6 415.5 255.7 415.5 158.5 336.9 79.9 239.7 79.9zM199.8 359.5C158.1 343.6 128.4 303.1 128.4 255.7S158.1 167.8 199.8 151.6V359.5zM279.6 359.8V151.6C321.3 167.8 351 208.3 351 255.7S321.3 343.6 279.6 359.8zM528 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H528C554.5 480 576 458.5 576 432V80C576 53.5 554.5 32 528 32zM329.7 448H239.4C133.2 448 45.6 362.5 45.6 257.8 45.6 143.2 133.2 64 239.4 64H329.7C434.7 64 530.4 143.2 530.4 257.8 530.4 362.5 434.7 448 329.7 448z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cc-diners-club.js
// module id = is3L
// module chunks = 0